import script from "./UserEditPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./UserEditPanel.vue?vue&type=script&setup=true&lang=js"

import "./UserEditPanel.vue?vue&type=style&index=0&id=59f327eb&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f327eb"]])

export default __exports__